import { Component, OnInit, AfterViewInit, OnDestroy, ElementRef, ViewChild, Renderer2 } from '@angular/core';
import { MessageService } from 'primeng/api';
import { FuelEntry } from '../interfaces';
import { FuelService } from '../services/fuel.service';

interface MonthOption {
  label: string;
  value: number;
}

interface YearOption {
  label: string;
  value: number;
}

@Component({
  selector: 'app-fuel-entries',
  templateUrl: './fuel-entries.component.html',
  styleUrls: ['./fuel-entries.component.scss'],
})
export class FuelEntriesComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('tableAnchor') tableAnchor!: ElementRef<HTMLElement>;

  entries: FuelEntry[] = [];
  isLoading = false;
  tableHeight = '400px';

  private resizeObserver?: ResizeObserver;

  filterYear: number | undefined = new Date().getFullYear();
  filterMonth: number | undefined = undefined;

  monthOptions: MonthOption[] = [
    { label: 'January', value: 1 },
    { label: 'February', value: 2 },
    { label: 'March', value: 3 },
    { label: 'April', value: 4 },
    { label: 'May', value: 5 },
    { label: 'June', value: 6 },
    { label: 'July', value: 7 },
    { label: 'August', value: 8 },
    { label: 'September', value: 9 },
    { label: 'October', value: 10 },
    { label: 'November', value: 11 },
    { label: 'December', value: 12 },
  ];

  yearOptions: YearOption[] = [];

  private mainContent: HTMLElement | null = null;

  constructor(
    private fuelService: FuelService,
    private messageService: MessageService,
    private renderer: Renderer2
  ) {}

  ngOnInit(): void {
    this.buildYearOptions();
    this.loadEntries();
  }

  ngAfterViewInit(): void {
    this.mainContent = document.querySelector('.main-content');
    if (this.mainContent) {
      this.renderer.setStyle(this.mainContent, 'overflow-y', 'hidden');
    }
    this.calculateTableHeight();
    this.resizeObserver = new ResizeObserver(() => this.calculateTableHeight());
    this.resizeObserver.observe(document.documentElement);
  }

  ngOnDestroy(): void {
    if (this.mainContent) {
      this.renderer.removeStyle(this.mainContent, 'overflow-y');
    }
    this.resizeObserver?.disconnect();
  }

  calculateTableHeight(): void {
    if (!this.tableAnchor?.nativeElement) return;
    const anchorTop = this.tableAnchor.nativeElement.getBoundingClientRect().top;
    const tableHeaderHeight = 46;
    const bottomPadding = 24;
    this.tableHeight = `${Math.max(window.innerHeight - anchorTop - tableHeaderHeight - bottomPadding, 200)}px`;
  }

  buildYearOptions(): void {
    const currentYear = new Date().getFullYear();
    for (let y = currentYear; y >= currentYear - 5; y--) {
      this.yearOptions.push({ label: String(y), value: y });
    }
  }

  loadEntries(): void {
    this.isLoading = true;
    this.fuelService.getFuelEntries(this.filterYear, this.filterMonth).subscribe({
      next: (data) => {
        this.entries = data;
        this.isLoading = false;
      },
      error: () => {
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Failed to load fuel entries.',
        });
        this.isLoading = false;
      },
    });
  }

  onFilterChange(): void {
    this.loadEntries();
  }
}
